export default __webpack_public_path__ + "static/media/no-task-update.2c7a63a3.png";